<template>
  <v-row>
    <v-col cols="12" md="12">
      <v-alert color="warning" outlined text type="info" dense>
        {{ text }}
      </v-alert>
    </v-col>
  </v-row>
</template>

<script>
import i18n from '../../../i18n';
export default {
  name: 'Unsaved-changes',
  props: {
    text: {
      type: String,
      default: i18n.t('unsaved-changes'),
    },
  },
};
</script>
